export default class DealerPageRepository {
  // @param dealerPageUrl <String> to fetch dealer page data for
  // @raise <NotFoundError> if the dealer page is not found
  // @raise <ServerError> if a server error is encountered
  // @return dealerPage <DealerPageEntity> the dealer page
  // eslint-disable-next-line class-methods-use-this
  static fetchByDealerPageUrl() {
    throw new Error('must be implemented in subclass');
  }
}
